import React from 'react';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import NavBar from './components/NavBar';
import Gallery from './components/Gallery';
import About from './components/About';
import Contact from './components/Contact';
import Store from './components/Store';
import Home from './components/Home'; // Assuming Home is also a component\
import Exhibition from './components/Exhibition'; // Assuming Exhibition is also a component
import Footer from './components/Footer'; // Assuming Footer is also a component
import '@fortawesome/fontawesome-free/css/all.min.css';
import { AuthProvider } from './context/AuthContext';
import Auth from './components/auth/Auth';
import AdminPanel from './components/admin/AdminPanel';

function App() {
    return (
        <Router>
            <AuthProvider>
                <NavBar />
                <Routes>
                    <Route path="/" element={<Home />} />
                    <Route path="/gallery" element={<Gallery />} />
                    <Route path="/gallery/:series" element={<Gallery />} />
                    <Route path="/about" element={<About />} />
                    <Route path="/store" element={<Store />} />
                    <Route path="/contact" element={<Contact />} />
                    <Route path="/exhibition" element={<Exhibition />} />
                    <Route path="/login" element={<Auth />} />
                    <Route path="/signup" element={<Auth />} />
                    <Route path="/admin" element={<AdminPanel />} />
                </Routes>
                <Footer />
            </AuthProvider>
        </Router>
    );
}

export default App;